import React, { ReactChildren, ReactChild, useState } from "react";
import styled, { ThemeProvider } from "styled-components";
import { useDarkMode } from "./useDarkMode";
import { theme, darkTheme, GlobalStyles } from "../../styles";
import { Footer } from "../footer";
import { Link as GatsbyLink } from "gatsby";

export interface Props {
  children: ReactChild | ReactChildren;
  banner?: boolean;
  pageColor?: string;
}

const Katanya = styled.div`
  min-height: 100vh;
  main {
    transform: translateY(-80px);
    min-height: calc(100vh - 300px);
    overflow: hidden;
    max-width: 100vw;
    position: relative;
  }
  [role="banner"] {
    z-index: 700;
    position: relative;
    background: ${(props) => props.theme.colors.gondola};
    color: white;
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-around;
    padding: 0 10px 0 10px;
    a {
      &:hover {
        color: ${(props) => props.theme.colors.salmon};
      }
      margin: 0 auto;
      padding: 12px 10px 15px 10px;
      text-decoration: none;
      &:before {
        content: "";
        position: absolute;
        background-size: 18px 18px;
        height: 18px;
        width: 18px;
        display: block;
        top: 15px;
        background-image: url("data:image/svg+xml,%3Csvg aria-hidden='true' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512'%3E%3Cpath fill='%23fff' d='M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z'%3E%3C/path%3E%3C/svg%3E");
      }
      span {
        font-weight: 300;
        color: white;
        padding-left: 32px;
      }
    }
  }

  .topNav {
    position: absolute;
    display: inline-block;
    z-index: 520;
    height: 80px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: ${(props) =>
      props.pageColor
        ? props.theme.colors[props.pageColor]
        : props.theme.colors.glass};
    @supports (position: sticky) {
      position: sticky;
      top: 0;
    }
    .ham {
      @media (min-width: ${(props) => props.theme.breakpoints.sm}px) {
        display: none;
      }
      label {
        position: relative;
        width: 35px;
        height: 25px;
        display: inline-block;
        cursor: pointer;
        margin: 1em;
        transition: all .5s;
        text-align: left;
        div,
        div:before,
        div:after {
          background: white;
          position: absolute;
          height: 5px;
          width: 35px;
          transition: all .5s;
        }
        div:first-child {
          top: 0px;
        }
        div:nth-child(2) {
          top: 13px;
        }
        div:nth-child(3) {
          top: 25px;
        }
      }
      #menu {
        display: none;
      }
      #menu {
        + {
          label {
            div {
              transition: top .15s .3s, -webkit-transform .15s .12s;
              transition: top .15s .3s, transform .15s .12s;
              transition: top .15s .3s, transform .15s .12s, -webkit-transform .15s .12s;
              &:nth-child(3) {
                transition: top .15s .3s, -webkit-transform .3s;
                transition: top .15s .3s, transform .3s;
                transition: top .15s .3s, transform .3s, -webkit-transform .3s;
              }
            }
          }
        }
        &:checked {
          + {
            label {
              div {
                top: 14px;
                transform: rotate(45deg);
                transition: top .15s, -webkit-transform .12s .15s;
                transition: top .15s, transform .12s .15s;
                transition: top .15s, transform .12s .15s, -webkit-transform .12s .15s;
                &:nth-child(3) {
                  transform: rotate(135deg);
                  transition: top .15s, -webkit-transform .3s .15s;
                  transition: top .15s, transform .3s .15s;
                  transition: top .15s, transform .3s .15s, -webkit-transform .3s .15s;
                }
              }
            }
          }
        }
      }
    }
    .site {
      display: none;
      @media (min-width: ${(props) => props.theme.breakpoints.sm}px) {
        display: flex;
        padding-right: 10px;
        display: flex;
        flex-wrap: nowrap;
        align-items: stretch;
      }
      a {
        color: white;
        text-decoration: none;
        flex-grow: 1;
        text-align: center;
        padding: 25px 12px;
        cursor: pointer;
      }
    }
    .logo {
      padding: 25px 5px 25px 25px;
      width: 100%;
      max-width: 300px;
      height: 80px;
      > div {
        height: 100%;
        background-repeat: no-repeat;
        background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 495.6 73'%3E%3Cdefs/%3E%3Cdefs%3E%3Cstyle%3E .cls-1%7Bfill:%23fff;fill-rule:evenodd%7D %3C/style%3E%3C/defs%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cpath d='M44 0L0 46v27h20V51l5-6 20 28h24L38 32 68 0H44z' class='cls-1'/%3E%3Cpath fill='%23fff' d='M0 1h20v19H0z'/%3E%3C/g%3E%3Cpath id='Layer_3' d='M260 309l6-14 5 14zm14-40h-17l-31 73h21l6-15h25l7 15h20z' class='cls-1' data-name='Layer 3' transform='translate(-152 -269)'/%3E%3Cpath id='Layer_4' d='M340 288h21v-19h-61v19h20v54h20z' class='cls-1' data-name='Layer 4' transform='translate(-152 -269)'/%3E%3Cpath id='Layer_5' d='M389 309l6-14 5 14zm45 33l-31-73h-17l-31 73h21l6-15h25l7 15z' class='cls-1' data-name='Layer 5' transform='translate(-152 -269)'/%3E%3Cpath id='Layer_6' d='M459 303l30 39h16v-73h-19v38l-29-38h-17v73h19v-39' class='cls-1' data-name='Layer 6' transform='translate(-152 -269)'/%3E%3Cpath id='Layer_7' d='M387 73V44L359 0h22l15 26 15-26h23l-28 45v28h-19z' class='cls-1' data-name='Layer 7'/%3E%3Cpath id='Layer_8' d='M603 309l5-14 6 14zm45 33l-31-73h-17l-31 73h20l6-15h26l6 15z' class='cls-1' data-name='Layer 8' transform='translate(-152 -269)'/%3E%3C/svg%3E%0A");
      }
    }
  }

`;

const Layout: React.FC<Props> = ({ children, banner, pageColor }) => {
  const [dark, toggleDark] = useDarkMode();
  const [menuOpen, setMenuOpen] = useState(false);

  function hamClick() {
    setMenuOpen(!menuOpen)
  }

  const themeMode = dark ? darkTheme() : theme();

  return (
    <ThemeProvider theme={themeMode}>
      <GlobalStyles />
      <Katanya pageColor={pageColor}>
        {banner && (
          <div role="banner">
            <GatsbyLink to="/covid19" name="covid19">
              <span>
                Coronavirus (COVID-19): How we're operating and how we can help
              </span>
            </GatsbyLink>
          </div>
        )}
        <nav className="topNav">
          <GatsbyLink
            to="/"
            name="kantaya"
            className="logo"
            aria-label="home link"
          >
            <div />
          </GatsbyLink>
          <div className="ham" onClick={hamClick}>
            <input type="checkbox" id="menu" name="menu" aria-labelledby="open mobile menu"/>
            <label for="menu">
              <div />
              <div />
              <div />
            </label>
          </div>
          <div className="site">
            <GatsbyLink to="/about" name="about us">
              About us
            </GatsbyLink>
            <GatsbyLink to="/services" name="services">
              Services
            </GatsbyLink>
            <GatsbyLink to="/tales" name="tales">
              Tales
            </GatsbyLink>
            <GatsbyLink to="/labs" name="labs">
              Labs
            </GatsbyLink>
            <GatsbyLink to="/contact" name="contact">
              Contact
            </GatsbyLink>
          </div>
        </nav>
        <main>{children}</main>
        <Footer role="contentinfo" />
      </Katanya>
    </ThemeProvider>
  );
};

export { Layout };
